import { X } from "lucide-react";

import { ButtonShadcn as Button } from "@/components/ui/Button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog";

const AlertModal = ({
  open = false,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  cancelText = "Cancel",
  actionText = "Continue",
  loading = false,
  // Disable the action while leaving Cancel live, for a dialog that has become
  // a blocking notice: the answer is no, and the only way out is to dismiss it.
  // Distinct from `loading`, which disables both and takes over the label.
  actionDisabled = false,
  // Hide the action entirely — a notice with nothing to confirm.
  hideAction = false,
  onOpenChange = () => {},
  onAction = () => {},
  onCancel = () => {},
  // Both default off — every existing AlertModal caller keeps today's
  // "must pick Cancel or Continue" behavior unless it opts in.
  showCloseButton = false,
  closeOnOverlayClick = false,

  // classNames
  contentClassName = "",
  titleClassName = "",
  descriptionClassName = "",
  footerClassName = "",
  cancelClassName = "",
  actionClassName = "",
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className={contentClassName}
        // AlertDialogContent hardcodes outside-interaction to preventDefault
        // by design (see its own comment) — `onOverlayClick` is its one
        // escape hatch, a plain click handler on the backdrop itself. Gated
        // on `loading` the same way the Cancel/Close buttons are below, so
        // an in-flight action can't be walked away from mid-flight.
        onOverlayClick={closeOnOverlayClick && !loading ? onCancel : undefined}
      >
        {showCloseButton && (
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            onClick={onCancel}
            disabled={loading}
            aria-label="Close"
            className="absolute right-3 top-3"
          >
            <X aria-hidden="true" />
          </Button>
        )}
        <AlertDialogHeader>
          <AlertDialogTitle className={titleClassName}>{title}</AlertDialogTitle>

          <AlertDialogDescription className={descriptionClassName}>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className={footerClassName}>
          <AlertDialogCancel onClick={onCancel} disabled={loading} className={cancelClassName}>
            {cancelText}
          </AlertDialogCancel>

          {!hideAction && (
            <AlertDialogAction onClick={onAction} disabled={loading || actionDisabled} className={actionClassName}>
              {loading ? "..." : actionText}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertModal;
